// features/fund/table/ContributionRateTable.jsx
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Form, Input, InputNumber, Select } from "antd";
import { useTranslation } from "react-i18next";
import styles from "../styles/Fund.module.css";
import { TIME_UNIT, emptyRateRule, getCriteriaColumnLabels, toOptions } from "../schemas/FundSchemas";
import { FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";

const ContributionRateTable = ({ positionOptions = [], disabled = false }) => {
    const { t, i18n } = useTranslation();
    const form = Form.useFormInstance();
    const unitOptions = toOptions(TIME_UNIT, i18n.language);

    // Column wording follows "เกณฑ์กำหนดอัตราเงินสะสมและเงินสมทบ" (อายุงาน / อายุสมาชิก)
    const contributionRateCriteria = Form.useWatch("contributionRateCriteria");
    const columnLabels = getCriteriaColumnLabels(contributionRateCriteria, i18n.language);

    // "ตำแหน่งงาน" column only appears when "กำหนดสิทธิ" is ticked AND scope = ตามตำแหน่ง
    const definedByPosition = Form.useWatch(["contributionRateConditions", "definedByPosition"]);
    const scope = Form.useWatch(["contributionRateConditions", "scope"]);
    const showPositionColumn = definedByPosition && scope === "POSITION";
    console.log("definedByPosition", definedByPosition, scope);

    const handlePositionChange = (rowName, value) => {
        const label = positionOptions.find((o) => o.value === value)?.label;
        form.setFieldValue(["contributionRateConditions", "rules", rowName, "positionName"], label);
    };

    return (
        <Form.List name={["contributionRateConditions", "rules"]}>
            {(fields, { add, remove }) => (
                <>
                    <table className={styles.ruleTable}>
                        <thead>
                            <tr>
                                {showPositionColumn && <th>{t("fund.label.position") || "ตำแหน่งงาน"}</th>}
                                <th>{columnLabels.from}</th>
                                <th>{t("fund.label.unit") || "หน่วย"}</th>
                                <th>{columnLabels.to}</th>
                                <th>{t("fund.label.unit") || "หน่วย"}</th>
                                <th>{t("fund.label.employeeRate") || "พนักงานสะสม (%)"}</th>
                                <th>{t("fund.label.employeeMaxRate") || "พนักงานสะสมสูงสุด (%)"}</th>
                                <th>{t("fund.label.companyRate") || "บริษัทสมทบ (%)"}</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {fields.map(({ key, name, ...restField }) => (
                                <tr key={key}>
                                    {showPositionColumn && (
                                        <td>
                                            <FormSelect
                                                {...restField}
                                                name={[name, "positionId"]}
                                                required
                                                style={{ marginBottom: 0, width: 140 }}
                                                options={positionOptions}
                                                placeholder={t("fund.placeholder.please_select") || "กรุณาเลือก"}
                                                onChange={(value) => handlePositionChange(name, value)}
                                                disabled={disabled}
                                            >
                                            </FormSelect>
                                            {/* hidden — keeps positionName in sync so the payload carries a readable label */}
                                            <Form.Item {...restField} name={[name, "positionName"]} hidden>
                                                <Input />
                                            </Form.Item>
                                        </td>
                                    )}
                                    <td>
                                        <FormInput
                                            {...restField}
                                            name={[name, "serviceFrom"]}
                                            // rules={[{ required: true, message: "" }]}
                                            style={{ marginBottom: 0 }}
                                            min={0}
                                            placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"}
                                            disabled={disabled}
                                        >
                                            {/* <InputNumber min={0} style={{ width: "100%" }} placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"} /> */}
                                        </FormInput>
                                    </td>
                                    <td>
                                        <FormSelect
                                            {...restField}
                                            name={[name, "serviceFromUnit"]}
                                            rules={[{ required: true, message: "" }]}
                                            style={{ marginBottom: 0, width: 96 }}
                                            options={unitOptions}
                                            disabled={disabled}
                                        >
                                        </FormSelect>
                                    </td>
                                    <td>
                                        <FormInput
                                            {...restField}
                                            name={[name, "serviceTo"]}
                                            // rules={[{ required: true, message: "" }]}
                                            style={{ marginBottom: 0 }}
                                            min={0}
                                            placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"}
                                            disabled={disabled}

                                        >
                                            {/* <InputNumber min={0} style={{ width: "100%" }} placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"} /> */}
                                        </FormInput>
                                    </td>
                                    <td>
                                        <FormSelect
                                            {...restField}
                                            name={[name, "serviceToUnit"]}
                                            rules={[{ required: true, message: "" }]}
                                            style={{ marginBottom: 0, width: 96 }}
                                            options={unitOptions}
                                            disabled={disabled}

                                        >
                                        </FormSelect>
                                    </td>
                                    <td>
                                        <FormInput
                                            {...restField}
                                            required
                                            name={[name, "employeeRatePercent"]}
                                            // rules={[{ required: true, message: "" }]}
                                            style={{ marginBottom: 0 }}
                                            min={0}
                                            placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"}
                                            disabled={disabled}
                                        >
                                            {/* <InputNumber min={0} style={{ width: "100%" }} placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"} /> */}
                                        </FormInput>
                                    </td>
                                    <td>
                                        <FormInput
                                            {...restField}
                                            required
                                            name={[name, "employeeMaxRatePercent"]}
                                            // rules={[{ required: true, message: "" }]}
                                            style={{ marginBottom: 0 }}
                                            min={0}
                                            placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"}
                                            disabled={disabled}
                                        >
                                            {/* <InputNumber min={0} style={{ width: "100%" }} placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"} /> */}
                                        </FormInput>
                                    </td>
                                    <td>
                                        <FormInput
                                            {...restField}
                                            required
                                            name={[name, "companyRatePercent"]}
                                            // rules={[{ required: true, message: "" }]}
                                            style={{ marginBottom: 0 }}
                                            min={0}
                                            placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"}
                                            disabled={disabled}
                                        >
                                            {/* <InputNumber min={0} style={{ width: "100%" }} placeholder={t("fund.placeholder.please_input") || "กรุณากรอก"} /> */}
                                        </FormInput>
                                    </td>
                                    <td>
                                        {!disabled && fields.length > 1 && (
                                            <DeleteOutlined className={styles.deleteIcon} onClick={() => remove(name)} />
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {!disabled && <Flex>
                        <Button
                            type="dashed"
                            icon={<PlusOutlined />}
                            className={styles.addRowButton}
                            onClick={() => add(emptyRateRule())}
                        >
                            {t("fund.label.addRow") || "เพิ่มรายการ"}
                        </Button>
                    </Flex>}
                </>
            )}
        </Form.List>
    );
};

export default ContributionRateTable;